
import React from 'react';
import {Loader_sidebar} from './loader_sidebar'
import star from './Images/star.png';
import goldstar from './Images/goldstar.png';
import {Doughnut, Pie} from 'react-chartjs-2';
import { Infoeach } from './infoeach';
import { centroid } from '@turf/centroid';

export class Piecharttotal extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
        values: ''
    }
  this.arrangement_image =  this.arrangement_image.bind(this);
  this.piecharstate = this.piecharstate.bind(this);
  } 
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
arrangement_image(){
  if(this.props.zoom == 2){
    if(this.props.arrangestar)
      return(<img src={goldstar} onClick={() => this.props.unsetarrangement(this.props.arrangement)} className="starredvalues-long starredvalues"></img> )
        
    return(<img src={star} onClick={() => this.props.setarrangement(this.props.arrangement)} className="starredvalues-long starredvalues"></img> )
  }
}
piecharstate(){
    if(this.state.values == ''){
        let type = this.props.occupation.map((e) => e.type);
        let value = this.props.occupation.map((e) => e.value);
        let total = value.reduce((a, b) => a + b, 0)
        value = value.map((e) => Math.round((e * 100) / total)/100)
        return {
            labels: type,
            datasets: [
              {
                
                backgroundColor: [
                  'rgba(254,240,199, 1)',
                  'rgba(254,200,75, 1)',
                  'rgba(247,144,9, 1)',
                  'rgba(220,104,3,1)',
                  'rgba(178,221,255,1)',
                  'rgba(83,177,253, 1)',
                  'rgba(21,112,239, 1)'
                ],
                hoverBackgroundColor: [
                  'rgba(254,240,199, .7)',
                  'rgba(254,200,75,  .7)',
                  'rgba(247,144,9,  .7)',
                  'rgba(220,104,3, .7)',
                  'rgba(178,221,255, .7)',
                  'rgba(83,177,253, .7)',
                  'rgba(21,112,239, .7)'
                ],
                data: value
              }
            ]
          }
    }else{
        let temp = this.props.occupation.filter((e) => {
            if(e.type == this.state.values)
            return e
        })
        let type = temp[0].subs.map((e) => e.type)
        let value = temp[0].subs.map((e) => e.value)
        let total = value.reduce((a, b) => a + b, 0)
        value = value.map((e) => Math.round((e * 100) / total)/100)
        return {
            labels: type,
            datasets: [
              {
                
                backgroundColor: [
                  'rgba(254,240,199, 1)',
                  'rgba(254,200,75, 1)',
                  'rgba(247,144,9, 1)',
                  'rgba(220,104,3,1)',
                  'rgba(178,221,255,1)',
                ],
                hoverBackgroundColor: [
                  'rgba(254,240,199, .7)',
                  'rgba(254,200,75,  .7)',
                  'rgba(247,144,9,  .7)',
                  'rgba(220,104,3, .7)',
                  'rgba(178,221,255, .7)',
                ],
                data: value
              }
            ]
          }
    }
}
piechartgoback(){
    this.setState({values: ''})
}


render() {
  const     options = {
    maintainAspectRatio: true,  // Add this line
    plugins: {
      legend: {
        position: this.props.exportInd ? 'left' : 'top'
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((acc, data) => acc + data, 0);
            const percentage = Math.round((value / total) * 100) + '%';
            return `${percentage}`;
          }
        }
      }
    }
  }

  const options_doughnut = {
    maintainAspectRatio: !this.props.exportInd,  // Add this line
    plugins: {

      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((acc, data) => acc + data, 0);
            const percentage = Math.round((value / total) * 100) + '%';
            return `${percentage}`;
          }
        }
      },
      legend: {
        position: this.props.exportInd ? 'left' : 'top',
        onHover: function(e) {
          if(e.target)
          e.target.style.cursor = 'pointer';
        }
      }
    },
    onHover: (event, chartElement) => {
      if (event.native) {
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
      }
    },
    onClick: (event, elements) => {
      if (elements && elements.length > 0) {
        const index = elements[0].index;
        const label = this.piecharstate().labels[index];
        this.setState({values: label});
      }
    }
  };
      
    return (<div className="barchart-horizontal piechart-horizontal"><Infoeach margin={this.props.margin} description={this.props.description} filters={this.props.filters}/>
   <div className="boxdata-header">{this.props.top_text}</div>{this.arrangement_image()}
    {(this.props.type)?  
    <div className='graphs-container-main'>
    {(this.state.values != '')? <div className="box-price box-showmore" onClick={this.piechartgoback.bind(this)}><div id="box-goback">Back</div></div>: null}
    {(this.state.values !== "") &&<div className="box-industry-piechart box-industry-type-pie box-industry-type">{ this.state.values}</div>}
    <div className={this.props.exportInd ? 'chart-container-sm' : ''}>{(this.state.values == '')?<Doughnut  id="barchart-employee" data={this.piecharstate()} 
    options={options_doughnut}  height={200}      width={400}
   
    />: <Pie  id="barchart-employee" data={this.piecharstate()} options={options}/>}</div>
    </div>
    : <Loader_sidebar/> }
    </div>);
      }
}